import * as React from 'react';
import {
    DOMHelper, ILoopConfig, IProperty, IOutput, PropertyHelper, IOperator,
    IValidationConfig, QueryBuilderHelper, IMoveHandler, EValidationContext, ILoopConfigSummaryColumn
} from '../../helpers';
import { DialogFooter, Button, ButtonType, Pivot, PivotItem, PivotLinkSize, IDropdownOption } from 'office-ui-fabric-react';
import { Properties, Validation } from '../';
import { LoopOutputs, LoopSummary } from './';

interface IProps {
    loopConfig: ILoopConfig;
    outputOptions: IDropdownOption[];
    localLoopOutputOptions: IDropdownOption[];
    operators: IOperator[];
    operatorTypes: string[];
    outputsMoveHandler: IMoveHandler;
    summaryMoveHandler: IMoveHandler;
    types: IDropdownOption[];
    closeDialog: (save?: boolean) => void;
    updateLoopConfig: (loopConfig: ILoopConfig) => void;
    showPivotErrorMessage: () => void;
}

export class LoopConfigDialog extends React.Component<IProps, any> {

    SummaryProperties: string[] = ["Pre Summary Content", "Post Summary Content", "Remove All Rows Confirmation Message", "Removed All Rows Message", "Row Added Message", "Row Removed Message"];

    updateProperties = (loopConfigProperties: IProperty[]) => {

        let { loopConfig, updateLoopConfig } = this.props;

        loopConfig.Properties = loopConfigProperties;

        updateLoopConfig(loopConfig);

    }

    updateOutputs = (outputs: IOutput[]) => {

        let { loopConfig, updateLoopConfig } = this.props;

        outputs = outputs.map(o => {
            return {
                ...o,
                LoopId: loopConfig.componentId
            };
        })

        loopConfig.OutputValues = outputs;

        updateLoopConfig(loopConfig);

    }

    updateEditedValidationItem = (editedValidationItem: IValidationConfig) => {

        let { loopConfig, updateLoopConfig } = this.props;

        loopConfig.editedValidationItem = editedValidationItem;

        updateLoopConfig(loopConfig);

    };

    setValidationEditIndex = (validationEditIndex: number) => {

        let { loopConfig, updateLoopConfig } = this.props;

        loopConfig.validationEditIndex = validationEditIndex;
        if (validationEditIndex == null) {
            loopConfig.editedValidationItem = null;
        }

        updateLoopConfig(loopConfig);

    };

    updateValidationProperty = (validationExpressionsName: string, value: string) => {

        let { loopConfig } = this.props;

        let validationProperty = loopConfig.Properties.filter(p => p.Name === validationExpressionsName)[0];

        if (validationProperty) {
            validationProperty.Value = value;
        }

        this.updateProperties(loopConfig.Properties);

    };

    updateSummaryColumns = (summaryColumns: ILoopConfigSummaryColumn[]) => {

        let { loopConfig, updateLoopConfig } = this.props;

        loopConfig.summaryColumns = summaryColumns;

        updateLoopConfig(loopConfig);
    }

    render() {

        let { loopConfig, closeDialog, outputOptions, showPivotErrorMessage, outputsMoveHandler, summaryMoveHandler, types, localLoopOutputOptions } = this.props;

        let combinedOutputOptions = outputOptions;
        for (let i = 0; i < loopConfig.OutputValues.length; i++) {
            if (!combinedOutputOptions.filter(o => o.key === loopConfig.OutputValues[i].Id).length) {
                combinedOutputOptions.push({
                    key: loopConfig.OutputValues[i].Id,
                    text: loopConfig.OutputValues[i].Name
                });
            }
        }

        let combinedOutputOptionsProps = outputOptions.concat(localLoopOutputOptions);
        let pivots: JSX.Element[] = [];

        pivots.push(<PivotItem key='pivot_properties' linkText='Properties'>
            <Properties
                primaryOnly={false}
                change={(Name: string, Value: any, componentId: string) => {
                    let propertyToUpdate = loopConfig.Properties.filter(p => p.Name === Name)[0];
                    if (propertyToUpdate) {
                        propertyToUpdate.Value = Value;
                    }
                    this.updateProperties(loopConfig.Properties);
                }}
                componentId={loopConfig.componentId}
                properties={loopConfig.Properties.filter(p => this.SummaryProperties.indexOf(p.Name) < 0)}
                // properties={loopConfig.Properties}
                outputOptions={combinedOutputOptionsProps}
            />
        </PivotItem>);

        pivots.push(<PivotItem key='pivot_outputs' linkText='Outputs'>
            <LoopOutputs
                outputs={loopConfig.OutputValues}
                overIndex={loopConfig.overIndex}
                moveHandler={outputsMoveHandler}
                types={types}
                updateOutputs={this.updateOutputs}
            />
        </PivotItem>);

        pivots.push(<PivotItem key='pivot_summary' linkText='Summary'>
            <LoopSummary
                localLoopOutputOptions={localLoopOutputOptions}
                loopSummaryProperties={loopConfig.Properties.filter(p => this.SummaryProperties.indexOf(p.Name) >= 0)}
                summaryColumns={loopConfig.summaryColumns}
                overIndex={loopConfig.overIndex}
                moveHandler={summaryMoveHandler}
                outputOptions={combinedOutputOptions}
                componentId={loopConfig.componentId}
                updateSummaryProperty={(Name: string, Value: any) => {
                    let propertyToUpdate = loopConfig.Properties.filter(p => p.Name === Name)[0];
                    if (propertyToUpdate) {
                        propertyToUpdate.Value = Value;
                    }
                    this.updateProperties(loopConfig.Properties);
                }}
                updateSummaryColumns={this.updateSummaryColumns}
            />
        </PivotItem>
        );

        //Validation panel
        let validationExpressions = PropertyHelper.getProperty(loopConfig.Properties, 'Validation Expression');
        if (validationExpressions) {

            let { operators, operatorTypes } = this.props;

            pivots.push(<PivotItem key='pivot_validation' linkText='Validation'>
                <Validation
                    operators={operators}
                    operatorTypes={operatorTypes}
                    value={validationExpressions.Value}
                    validationEditIndex={loopConfig.validationEditIndex}
                    editedValidationItem={loopConfig.editedValidationItem}
                    validationContext={EValidationContext.Loop}
                    onChange={(value: string) => {
                        this.updateValidationProperty(validationExpressions.Name, value);
                    }}
                    updateEditedValidationItem={this.updateEditedValidationItem}
                    setValidationEditIndex={this.setValidationEditIndex}
                    outputOptions={combinedOutputOptions}
                    defaultOutputOption={null}
                />
            </PivotItem>);
        }

        let showPivotBlocker: boolean = !QueryBuilderHelper.canSaveQueryEditor() || loopConfig.validationEditIndex != null;

        // return <div>This is Loop Config Dialog.</div>
        return <div className={'loop-config-wrapper' + (showPivotBlocker ? ' pivots-blocked' : '')}>

            {showPivotBlocker ? <div className={"pivot-blocker"} onClick={showPivotErrorMessage}></div> : null}

            <Pivot linkSize={PivotLinkSize.large}>
                {pivots}
            </Pivot>

            <DialogFooter>
                <Button tabIndex={1001} buttonType={ButtonType.normal} onClick={() => closeDialog(false)}>Cancel</Button>
                <Button tabIndex={1002} buttonType={ButtonType.primary} id="decision-config-save"
                    onClick={() => closeDialog(true)} onBlur={() => { DOMHelper.focusOnFirstModalTabbableControl(); }}>Save</Button>
            </DialogFooter>

        </div>;

    }

}


// WEBPACK FOOTER //
// ./source/ts/components/loop/loop-config.tsx